import { combineReducers } from 'redux';
import { selectedFaresReducer } from './selectedFares/reducers';
import { currentLegReducer } from './currentLeg/reducers';
import { legsReducer } from './legs/reducers';
import legInView from './legInView/reducers';
import infoMessagesReducer from './infoMessages/reducers';
import searchResultsReducer from './searchResults/reducers';
import { errorReducer } from '@entities/error';
export const rootReducer = combineReducers({
    selectedFares: selectedFaresReducer,
    currentLeg: currentLegReducer,
    legs: legsReducer,
    legInView,
    infoMessages: infoMessagesReducer,
    searchResults: searchResultsReducer,
    error: errorReducer
});
